import { Injectable } from '@angular/core';
import {
  MyHttpClientFactory,
  ResponseCasingEnum,
  environment,
} from '@ups/xplat/core';
import { HttpClient } from '@angular/common/http';
import { IndustryCodeDto } from '@ups/xplat/api/dto';

//** @deprecated Used in Legacy Quote Log form. For Srf it is replaced by service-request.service.ts::getServiceDropdowns() */
@Injectable({
  providedIn: 'root',
})
export class IndustryCodeVPService {
  private vpHttp: HttpClient;

  constructor(private clientFactory: MyHttpClientFactory) {
    this.vpHttp = this.clientFactory.createHttpClient(
      environment.urls.viewpointAPI,
      true,
      ResponseCasingEnum.CamelCase
    );
  }

  //** @deprecated Used in Legacy Quote Log form. For Srf it is replaced by service-request.service.ts::getServiceDropdowns() */
  get() {
    return this.vpHttp.get<IndustryCodeDto[]>(`/api/quotelog/industryCodes`);
  }
}
